import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs4() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`IV.`}
            <br />
            {`Cena služeb a platební podmínky`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Uživatel je povinen hradit za službu cenu (úplatu) podle aktuálního ceníku poskytovatele platného při objednání služby. Aktuální ceník je k dispozici u jednotlivé služby příslušného lektora, který sám určuje jeho výši. Ceny jsou uvedeny v Kč. Stane-li se poskytovatel plátcem DPH, bude k ceně za služby připočteno DPH o čemž bude uživatel informován v aktuálním ceníku.`}</li>
            <li>{`Uživatel bere na vědomí, že úplata za služby je možná rovněž prostřednictvím systému PayU společnosti PayU S.A. se sídlem 60-166 Poznaň, ul. Grunwaldzka 186, 60-166 Poznaň, Polsko, kancelář v ČR Na Strži 61a, 140 00 Praha 4 zapsaná v rejstříku podnikatelů vedeném Okresním soudem v Poznani – Nowe Miasto i Wilda v Poznani, 8. obchodní oddělení Národního soudního rejstříku pod číslem KRS 274399, se základním kapitálem 4 944 000 PLN, splaceným v plné výši, daňové číslo (NIP): 779-23-08-495 více info na https://czech.payu.com/.`}</li>
            <li>{`Poskytovatel je oprávněn ceník změnit, a to zveřejněním nového ceníku. Změna ceny se nedotýká již běžících smluv uzavřených na sjednané období.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`V případě volby automatického hrazení služby na dobu neurčitou (tj. strhávání úplaty z bankovní karty uživatele či jeho účtu, pokud to zvolený systém úhrady umožňuje), uživatel objednávkou vyslovuje souhlas s tím, aby byla poskytovatelem anebo provozovatelem příslušného platebního systému provedena automatická úhrada sjednaných částek v příslušném intervalu bez potřeby osobní autorizace platby ze strany uživatele. Frekvence automatického placení odpovídá zvolenému platebnímu období, přičemž k úhradě na následující období bude docházet vždy na konci příslušného období. Uživatel je oprávněn změnit způsob úhrady ve svém uživatelském rozhraní.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs4;
